export const BUYER_SMS_CONSENT_TEXT =
  'By adding your mobile number, you agree to get texts from Paction about breeder messages, matches and your account. Message frequency varies. Message and data rates may apply. Reply STOP to opt out or HELP for help.';

export const BUYER_SMS_CONSENT_VERSION = '2026-10-16';
